import Mscratch from '../services/mscratch';

const print = (type, msg, tag) => {
    if (Mscratch.logger) {
        Mscratch.logger[type](msg, tag);
    } else {
        console[type](msg);
    }
};

class Logger {

    log(msg, tag = '') {
        print('log', msg, tag);
    }

    info(msg, tag = '') {
        print('info', msg, tag);
    }

    warn(msg, tag = '') {
        print('info', msg, tag);
    }

    error(msg, tag = '') {
        print('info', msg, tag);
    }

    trace(msg, tag = '') {
        print('info', msg, tag);
    }

    debug(msg, tag = '') {
        print('info', msg, tag);
    }
}

let inst = new Logger();

export default inst;